<!-- this wrapper needed if you intended to have transition for map
container. Directy, transform map container will cause panning issue in chrome   
-->
<div class="map-container-wrapper {isFtus && isMobile ? 'isFtus': "" }">
  <div class="map-container" bind:this={mapContainer}></div>
  {#if (isFtus && !isMobile)}
    <div class="map-container-blocker">
      <h1>Select options on the left and click 'Show on Map' to see the flood map.</h1>
    </div>
  {/if}
  {#if !isMobile}
    <SocialShare />
    <div class="legend-container">
      {#if showLegend}
        <div transition:fade="{{delay: 250, duration: 300, easing: quintOut}}">
          <Legend on:close={toggleLegend}/>
        </div>
      {:else}
        <button 
          class="button" 
          on:click={toggleLegend} 
          transition:fade="{{delay: 250, duration: 300, easing: quintOut}}">SHOW MAP KEY</button>
      {/if}
    </div>
  {/if}
  <BasemapWidget />
</div>



<script>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadModules, loadCss, setDefaultOptions } from "esri-loader";
import store, { STATES_LANDING, STATES_MAIN, STATES_FIRST_VISIT, STATES_START } from "../../state";
import { MapLayers, FloodLikelihoodOptions } from "../../services";
import storage from "../../services/StorageService";
import BasemapWidget from "../BasemapWidget/BasemapWidget.svelte";
BasemapWidget;
import SocialShare from "../SocialShare/SocialShare.svelte";
SocialShare;
import Legend from "../Legend/Legend.svelte";
Legend;
import { quintOut } from "svelte/easing";
quintOut;
import { fade } from "svelte/transition";
fade;
import qs from "qs";
import utils from "../../utils";
utils.isIE() && setDefaultOptions({ version: "4.12" });
export let isFtus;
export let isMobile;
let mapContainer;
let mapView;
let prevIsMobile;
let zoomWidget;
let locateWidget;
let mapViewService;
let currentSelectedLocation;
let prevSelectedLocation;
let appState = undefined;
let showLegend = true;
$: {
    //@ts-ignore
    if (mapView && isMobile !== prevIsMobile) {
        setupWidget();
        //@ts-ignore
        prevIsMobile = isMobile;
    }
    if (currentSelectedLocation) {
        if (!prevSelectedLocation ||
            currentSelectedLocation.attributes.OBJECTID !=
                prevSelectedLocation.attributes.OBJECTID) {
            prevSelectedLocation = currentSelectedLocation;
            focusOnFeature(currentSelectedLocation, currentSelectedLocation.layer);
        }
    }
    else {
        prevSelectedLocation = undefined;
    }
}
store.subscribe(state => {
    const isAppAuthenticated = state.currentState.includes(`${STATES_MAIN.LANDING}.${STATES_LANDING.AUTHENTICATE_APP_SUCCESS}`);
    if (isAppAuthenticated && !mapViewService) {
        mapViewService = state.mapViewService;
        loadMap(state.config.webMapId);
    }
    currentSelectedLocation = state.selectedLocation;
});
function loadMap(webMapId) {
    loadCss();
    loadModules([
        "esri/views/MapView",
        "esri/WebMap",
        "esri/widgets/Zoom",
        "esri/layers/GraphicsLayer"
        // "esri/widgets/Locate",
    ])
        .then(([MapView, WebMap, Zoom, GraphicsLayer
    // Locate
    ]) => {
        const webMap = new WebMap({
            portalItem: {
                id: webMapId
            }
        });
        const graphicsLayer = new GraphicsLayer({
            title: MapLayers.GRAPHICS
        });
        const blinkLayer = new GraphicsLayer({
            title: MapLayers.BLINK
        });
        webMap.add(graphicsLayer);
        webMap.add(blinkLayer);
        mapView = new MapView({
            map: webMap,
            container: mapContainer,
            highlightOptions: {
                color: "#ffa500",
                haloOpacity: 1,
                fillOpacity: 0
            },
            constraints: {
                minZoom: 10,
                maxZoom: 16,
                snapToZoom: true
            }
        });
        //Disabled for relaunched 2.0. Will enabled with further enhancement
        // locateWidget = new Locate({
        //   view: mapView
        // });
        zoomWidget = new Zoom({
            view: mapView
        });
        mapView.popup = null;
        window.mapView = mapView;
        setupWidget();
        mapView.when(() => __awaiter(this, void 0, void 0, function* () {
            //Check qs here
            window.top.history.replaceState(null, "", decodeURIComponent(window.top.location.search));
            const qsObj = qs.parse(window.top.location.search, {
                ignoreQueryPrefix: true
            });
            appState = qsObj.as || undefined;
            const storedTnc = storage.getItem("ses-tnc")
                ? JSON.parse(storage.getItem("ses-tnc"))
                : false;
            const storedSuburb = qsObj.sb
                ? qsObj.sb
                : storage.getItem("ses-suburb") || "";
            let storedState = appState
                ? appState
                : storage.getItem("ses-state") || "";
            // In mobile home always first visit search
            if (isMobile) {
                storedState = `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCH}`;
            }
            let storedFloodLikelihood = "";
            if (qsObj.flkhd) {
                const urlFloodLikelihood = utils.kebabCase(qsObj.flkhd);
                storage.setItem("ses-flood", urlFloodLikelihood);
                storedFloodLikelihood = urlFloodLikelihood;
            }
            else {
                storedFloodLikelihood = storage.getItem("ses-flood") || "";
            }
            const feature = storedSuburb !== ""
                ? yield (mapViewService === null || mapViewService === void 0 ? void 0 : mapViewService.getFeature(storedSuburb, mapView))
                : undefined;
            const floodLikelihood = storedFloodLikelihood !== ""
                ? FloodLikelihoodOptions.find(item => item.value === storedFloodLikelihood)
                : undefined;
            store.update(state => {
                if (storedTnc)
                    state.tncAcccepted = storedTnc;
                state.currentState = storedTnc
                    ? storedState
                    : `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.DEFAULT}`;
                state.mapViewService.setMapView(mapView);
                if (feature) {
                    state.riskProfile = feature.attributes;
                    state.selectedLocation = feature;
                }
                if (floodLikelihood) {
                    state.selectedLikelihood = floodLikelihood;
                    state.mapViewService.setVisibleFloodLayer(floodLikelihood.value);
                }
                return state;
            });
            mapView.on("click", (event) => {
                if (isMobile && event.pointerType === "mouse") {
                    return;
                }
                mapView.hitTest(event).then((response) => {
                    if (response.results.length) {
                        const boundaryResult = response.results.find(r => r.graphic.layer.title === MapLayers.BOUNDARY);
                        if (boundaryResult) {
                            mapView.container.setAttribute("style", "cursor: progress");
                            store.update(state => {
                                state.selectedLocation = boundaryResult.graphic;
                                return state;
                            });
                        }
                    }
                });
            });
            // // mapView.on("drag", evt => {
            // //   if (evt.action === "end") {
            // //     const watcher = mapView.watch("stationary", val => {
            // //       mapViewService?.blinkFeatureLayer(mapView.center);
            // //       watcher.remove();
            // //     });
            // //   }
            // // });
        }));
    })
        .catch(err => {
        console.error(err);
    });
}
function setupWidget() {
    mapView.ui.empty("top-left");
    if (!isMobile) {
        mapView.ui.add(zoomWidget, "top-left");
    }
    //NOTE: To be enabled when locate widget being enabled back
    // if (isMobile) {
    //   mapView.ui.add(locateWidget, "bottom-left");
    // } else {
    //   mapView.ui.add(zoomWidget, "top-left");
    //   mapView.ui.add(locateWidget, "top-left");
    // }
}
function focusOnFeature(feature, boundaryLayer) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (feature.attributes.AOI === "IN") {
                yield (mapViewService === null || mapViewService === void 0 ? void 0 : mapViewService.focusOnFeature(feature, boundaryLayer, isMobile));
                mapView.container.setAttribute("style", "");
            }
            else {
                mapViewService === null || mapViewService === void 0 ? void 0 : mapViewService.unfocusFeature();
                mapView.container.setAttribute("style", "");
            }
            store.update(state => {
                var _a;
                state.riskProfile = feature.attributes;
                storage.setItem("ses-suburb", (_a = state.riskProfile) === null || _a === void 0 ? void 0 : _a.Suburb);
                if (state.tncAcccepted) {
                    state.splashHide = true;
                    state.currentState = isFtus
                        ? `${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCH}`
                        : storage.getItem("ses-state")
                            ? storage.getItem("ses-state")
                            : `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
                }
                return state;
            });
        }
        catch (e) {
            console.error(e);
        }
    });
}
function toggleLegend() {
    showLegend = !showLegend;
}
function closeLegend() {
    console.log("hi");
}
</script>


<style>.map-container-wrapper{width:100%;height:100%;transform:translateX(0);transition:transform .3s cubic-bezier(.465,.183,.153,.946) .25s;position:relative}.map-container-wrapper.isFtus{transform:translateX(100%)}.map-container{width:100%;height:100%}.map-container-blocker{width:100%;height:100%;position:absolute;top:0;left:0;background-color:rgba(0,0,0,.85);display:flex;justify-content:center;align-items:center;padding:0 9.5rem;z-index:4}.map-container-blocker h1{color:#fff;font-size:2.875rem;font-family:AvenirLT-Black;line-height:63px}.legend-container{position:absolute;right:18px;width:24rem;bottom:30px;display:flex;justify-content:flex-end}.legend-container .button{font-family:AvenirLT-Heavy;font-size:14px;background-color:#d2d2d2;border:1px solid hsla(0,0%,50.2%,.2);box-shadow:0 1px 2px 0 rgba(0,0,0,.2)}</style>
